import type { ComponentType, ReactNode } from 'react';
import clsx from 'clsx';
import {
  GitHubIcon,
  //   InstagramIcon,
  LinkedInIcon,
  XIcon,
} from '~/components/SocialIcons';
import { Link } from '@remix-run/react';

type SocialLinkProps = {
  className?: string;
  href: string;
  icon: ComponentType<{ className?: string }>;
  children: ReactNode;
};

function SocialLink({
  className,
  href,
  children,
  icon: Icon,
}: SocialLinkProps) {
  return (
    <li className={clsx(className, 'flex')}>
      <Link
        to={href}
        target="_blank"
        className="group flex text-sm font-medium text-zinc-800 transition hover:text-sky-500 dark:text-zinc-200 dark:hover:text-sky-500"
      >
        <Icon className="h-6 w-6 flex-none fill-zinc-500 transition group-hover:fill-sky-500" />
        <span className="ml-4">{children}</span>
      </Link>
    </li>
  );
}

export function SocialLinks() {
  return (
    <ul>
      <SocialLink href="https://linkedin.com/in/eddyrecio" icon={LinkedInIcon}>
        Let's connect
      </SocialLink>
      <SocialLink href="https://x.com/eddyrecio" icon={XIcon} className="mt-4">
        Follow me
      </SocialLink>
      <SocialLink
        href="https://github.com/dax70"
        icon={GitHubIcon}
        className="mt-4"
      >
        See what I'm working on
      </SocialLink>

      {/* <SocialLink href="#" icon={InstagramIcon} className="mt-4">
            Follow on Instagram
          </SocialLink> */}

      {/* <SocialLink
            href="mailto:spencer@planetaria.tech"
            icon={MailIcon}
            className="mt-8 border-t border-zinc-100 pt-8 dark:border-zinc-700/40"
          >
            spencer@planetaria.tech
          </SocialLink> */}
    </ul>
  );
}
